import { makeAutoObservable } from "mobx";
import {
    deleteFundingSource,
    getFundingSourceById,
    pagingFundingSource,
    saveOrUpdateFundingSource
} from 'app/services/FundingSourceService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { FundingSource } from "app/common/Model/FundingSource";
import { checkSearchObject } from "app/common/LocalFunction";

export default class FundingSourceStore {
    searchFundingSource = new SearchObject();
    pageFundingSource = null;
    selectedFundingSource = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingFundingSource = async () => {
        return await pagingFundingSource(this.searchFundingSource)
            .then(({ data }) => {
                this.pageFundingSource = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu nguồn tài trợ có lỗi")
            })
    }

    handleChangeFormSearch = (searchFundingSource) => {
        this.searchFundingSource = checkSearchObject(this.searchFundingSource, searchFundingSource);
        this.pagingFundingSource();
    }

    handleOpenFormCreateOrEdit = (fundingSourceId) => {
        if (Boolean(fundingSourceId)) {
            getFundingSourceById(fundingSourceId).then(({ data }) => {
                this.selectedFundingSource = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedFundingSource = new FundingSource();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateFundingSource = (fundingSource, { setSubmitting }) => {
        saveOrUpdateFundingSource(fundingSource)
            .then(() => {
                this.selectedFundingSource = null;
                toast.success("Lưu nguồn tài trợ thành công!");
                this.handleClosePopup();
                this.pagingFundingSource();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu nguồn tài trợ có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (fundingSource) => {
        this.selectedFundingSource = { id: fundingSource?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteFundingSource(this.selectedFundingSource?.id)
            .then(() => {
                if (this.searchFundingSource?.pageIndex > 1 && this.pageFundingSource?.content?.length === 1) {
                    this.searchFundingSource.pageIndex -= 1;
                }
                toast.success("Xóa nguồn tài trợ thành công!");
                this.handleClosePopup();
                this.pagingFundingSource();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa đơn vị tính có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchFundingSource = new SearchObject();
        this.pageFundingSource = null;
        this.selectedFundingSource = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    
}
